import Layout from "@/components/shared/Layout";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import HeroContactUs from '@/components/contact-us/HeroContactUs'
import BeAPartner from '@/components/contact-us/BeAPartner'
import ScrollAnimation from '@/components/shared/ScrollAnimation'
import Head from 'next/head'
import { META_IMAGE, SITE_URL } from "@/utils/meta";
import ContactForm from '@/components/shared/ContactForm'
import WhatsappButton from '@/components/shared/WhatsappButton'

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale || "az")),
    },
  };
}

const ContactUs = () => {
  const { t, i18n } = useTranslation();
  const pageUrl = `${SITE_URL}${i18n.language === "az" ? "" : `/${i18n.language}`}/contact-us`;
  return (
    <Layout>
      <Head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>{t("contact-us-page.meta-title")}</title>
        <meta name="keywords" content={t("contact-us-page.meta-keywords")} />
        <meta name="description" content={t("contact-us-page.meta-description")} />
        <meta name="image" content={META_IMAGE} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:site_name" content="peerstack.tech" />
        <meta property="og:title" content={t("contact-us-page.meta-title")} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:description" content={t("contact-us-page.meta-description")} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={META_IMAGE} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t("contact-us-page.meta-title")} />
        <meta name="twitter:url" content={pageUrl} />
        <meta name="twitter:description" content={t("contact-us-page.meta-description")} />
        <meta name="twitter:image" content={META_IMAGE} />
        {/*<script*/}
        {/*  type="application/ld+json"*/}
        {/*  dangerouslySetInnerHTML={{*/}
        {/*    __html: JSON.stringify({*/}
        {/*      "@context": "https://schema.org",*/}
        {/*      "@type": "Organization",*/}
        {/*      name: "PeerStack",*/}
        {/*      alternateName: "PeerStack Tech",*/}
        {/*      url: "https://peerstack.tech",*/}
        {/*      logo: Logo.src,*/}
        {/*      contactPoint: {*/}
        {/*        "@type": "ContactPoint",*/}
        {/*        telephone: "50 999 88 77",*/}
        {/*        contactType: "customer service",*/}
        {/*        areaServed: "AZ",*/}
        {/*        availableLanguage: "Azerbaijani",*/}
        {/*      },*/}
        {/*      sameAs: ["https://peerstack.tech/", "https://peerstack.tech/"],*/}
        {/*    }),*/}
        {/*  }}*/}
        {/*/>*/}
      </Head>
      <HeroContactUs />
      <ScrollAnimation delay={100}>
        <BeAPartner />
      </ScrollAnimation>
      <ScrollAnimation delay={100}>
        <ContactForm />
      </ScrollAnimation>
      <WhatsappButton />
    </Layout>
  );
};

export default ContactUs;